var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28399 0H2.95065V6.66667H4.28399V0ZM12.4173 6.66667H8.15065L7.61732 5.93333V4.6L8.15065 4H12.4173L12.9507 4.66667V6L12.4173 6.66667ZM5.75065 10.6667H1.48399L0.950653 10V8.66667L1.48399 8H5.75065L6.28399 8.66667V10L5.75065 10.6667ZM10.9507 0H9.61732V2.66667H10.9507V0ZM9.61732 8H10.9507V16H9.61732V8ZM4.28399 12H2.95065V16H4.28399V12ZM14.8173 12H19.0707L19.604 11.3333V10.0667L19.0707 9.4H14.8173L14.284 10.0667V11.3333L14.8173 12ZM17.6173 0H16.284V8H17.6173V0ZM16.284 13.3333H17.6173V16H16.284V13.3333Z",
    fill: "#213960"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.6ebbde712c638141322f9639a1c4c3e9.svg";
export { ForwardRef as ReactComponent };